import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import HomePage from "@/pages/HomePage";
import BookDetailPage from "@/pages/BookDetailPage";
import AdminPage from "@/pages/AdminPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import CartPage from "@/pages/CartPage";
import LibraryPage from "@/pages/LibraryPage";
import WishlistPage from "@/pages/WishlistPage";
import GiftPage from "@/pages/GiftPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AuthCallback from "@/components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Check URL for auth callbacks
  if (location.hash?.includes('session_id=') || location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/libro/:slug" element={<BookDetailPage />} />
      <Route path="/faq" element={<AboutPage />} />
      <Route path="/preguntas-frecuentes" element={<FAQPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/carrito" element={<CartPage />} />
      <Route path="/biblioteca" element={<LibraryPage />} />
      <Route path="/favoritos" element={<WishlistPage />} />
      <Route path="/regalo/:giftId" element={<GiftPage />} />
      <Route path="/privacidad" element={<PrivacyPage />} />
      <Route path="/terminos" element={<TermsPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  // Suppress cross-origin iframe errors from PostHog/analytics in dev
  useEffect(() => {
    const handler = (event) => {
      if (event.message && event.message.includes('cross-origin')) {
        event.preventDefault();
      }
    };
    window.addEventListener('error', handler);
    return () => window.removeEventListener('error', handler);
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <HelmetProvider>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
    </HelmetProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
